import React from 'react'
import styled from 'styled-components'
import { Badge } from '@chakra-ui/react'

const Container = styled.div`
    width: 350px;
    height: 100%;
    padding: 10px;
    border: 2px solid #DADADA;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    @media screen and (max-width: 873px){
        flex-direction: column-reverse;
        height: 345px;
        width: 350px;
     };
     @media screen and (max-width: 450px){
        width: 270px;
     };
`;

const BadgeDiv = styled.div`
     width: 100%;
`

const WrapText = styled.section`
    display: flex;
    flex-direction: column;
    font-size: 13px;
    height: 190px;
    width: 360px;
    margin: 15px;
    justify-content: space-between;

    @media screen and (max-width: 873px){
        margin: 15px;
        width: 100%;
     };
     @media screen and (max-width: 450px){
        margin: 10px;
     };
`

const ImageCard = styled.img`
    width: 20%;
    height: 20%;
    margin-top: 20px;
    margin-right: 20px;
    object-fit: cover;

    @media screen and (max-width: 873px){
        width: 25%;
        height: 25%;
        max-height: 115px;
        display: block;
        margin: auto;
     };
     @media screen and (max-width: 450px){
        width: 100px;
        height: 100px;
     };
`;


const Card = ({
    jabatan,
    perusahaan,
    durasi,
    lokasi,
    waktuPost, 
    logo,
    nominal}) => {
   
    return (
           <Container>
           <WrapText>
                <BadgeDiv>
                        {nominal !== null ? 
                            <Badge p={2} colorScheme='purple' fontSize='11px'>Biaya: {nominal}</Badge>
                        : 
                            <Badge p={2} colorScheme='purple' fontSize='11px'>Tidak dipungut biaya</Badge>
                        }
                </BadgeDiv>
                <br></br>
                <span style={{fontSize: '18px', paddingBottom:'10px'}}>{jabatan}</span>
                <span style={{fontWeight: '600'}}>{perusahaan}</span>
                <span style={{color: '#828282'}}>{durasi}</span>
                <span style={{color: '#828282'}}>{lokasi}</span>
                <span style={{color: '#0078CF'}}>Dipost {waktuPost}</span>
           </WrapText>
           <ImageCard src={logo}/>
           
       </Container>
    )
}

export default Card
